"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _Box = _interopRequireDefault(require("../../Box"));

var _Typography = require("../../Typography");

var _TableContext = _interopRequireDefault(require("./TableContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var verticalAlignMap = {
  left: 'flex-start',
  middle: 'center',
  right: 'flex-end'
};
var textAlignMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};

var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      pxProp = _ref.px,
      pyProp = _ref.py,
      pProp = _ref.p,
      caption = _ref.caption,
      textAlign = _ref.textAlign,
      verticalAlign = _ref.verticalAlign,
      minHeightProp = _ref.minHeight,
      props = _objectWithoutProperties(_ref, ["children", "px", "py", "p", "caption", "textAlign", "verticalAlign", "minHeight"]);

  var context = _react["default"].useContext(_TableContext["default"]);

  var spacing = context.spacing,
      responsive = context.responsive;
  var justifyContent = verticalAlignMap[verticalAlign];
  var alignItems = textAlignMap[textAlign];
  var smallJustify = responsive ? 'flex-start' : justifyContent;
  var smallAlign = responsive ? 'flex-start' : alignItems;
  var smallTextAlign = responsive ? 'left' : textAlign;
  var px = pxProp;
  var py = pyProp;
  var p = pProp;

  if (p === undefined) {
    if (px === undefined) {
      if (spacing === 'dense') {
        px = 2;
      } else {
        px = 3;
      }
    }

    if (py === undefined) {
      if (spacing === 'dense') {
        py = 1;
      } else {
        py = 2;
      }
    }
  }

  var minHeight = minHeightProp;

  if (minHeight === undefined) {
    if (spacing === 'dense') {
      minHeight = 24;
    } else {
      minHeight = 36;
    }
  }

  return _react["default"].createElement(_Box["default"], props, _react["default"].createElement(_Box["default"], {
    minHeight: minHeight,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: [smallJustify, justifyContent],
    alignItems: [smallAlign, alignItems],
    px: px,
    py: py,
    p: p,
    textAlign: [smallTextAlign, textAlign]
  }, caption && _react["default"].createElement(_Typography.Caption, {
    display: ['block', 'none', 'none', 'none'],
    color: "secondary",
    mb: 2
  }, caption), _react["default"].createElement(_Box["default"], null, children)));
};

TableCell.defaultProps = {
  theme: _theme["default"],
  flex: 1,
  textAlign: 'left',
  verticalAlign: 'middle',
  px: undefined,
  py: undefined,
  p: undefined,
  minHeight: undefined
};
var _default = TableCell;
exports["default"] = _default;